import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Hook to restore the user's route after a version update refresh
 * Checks sessionStorage for a saved route and navigates to it
 */
const useRouteRestore = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!sessionStorage?.getItem) {
      return;
    }
    const savedRoute = sessionStorage.getItem('preRefreshRoute');
    if (savedRoute) {
      if (!sessionStorage?.removeItem) {
        return;
      }
      // Clear the saved route so it doesn't interfere with future navigations
      sessionStorage.removeItem('preRefreshRoute');
      // Navigate to the saved route
      navigate(savedRoute, { replace: true });
    }
  }, [navigate]);
};

export default useRouteRestore;
